import React, { useEffect, useState } from 'react';
import {
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Box,
    Center,
    Text,
    Spinner,
    Flex
} from '@chakra-ui/react';

import Otp from './OTP';
import Transactions from './Transaction';
import { fetchWrapper } from '../../helpers';
import Header from '../../components/Header';
import { useLocation } from 'react-router-dom';
import API from '../../helpers/axiosInstance';
import { getApiHeaders, hasPermission } from '../../utils/DefaultFunction';
import Informational from './Infromational/Informational';
import Marketing from './Marketing/Marketing';
import BoxWrapper from '../../components/BoxWrapper/BoxWrapper';

const RoutingMethods = ({ header }) => {
    const [activeTab, setActiveTab] = useState(0);

    const [channelList, setchannelList] = useState([])
    let user = JSON.parse(localStorage.getItem('customer'))
    const customer_id = user?.customer_id


    const location = useLocation();
    const [permissions, setPermissions] = useState([]);
    const [loading, setLoading] = useState(false);

    const params = location.pathname.replace('/', "")

    const fetchPermissions = async () => {
        setLoading(true);
        try {
            const url = `${process.env.REACT_APP_API_URL}/permission/feature/list?slug=${params}`;
            const response = await API.get(url, { headers: getApiHeaders() });

            setPermissions(response.data.data || []);
        } catch (error) {
            console.error("Error fetching permissions:", error);
            setPermissions([]);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const routePermission = hasPermission("route-method", permissions)
    useEffect(() => {

        loadChannelList()
    }, [])

    const loadChannelList = async () => {
        setLoading(true)
        const url = `${process.env.REACT_APP_API_URL}/channel/list`;
        const data = await fetchWrapper.get(url)
        const listValue = data.data.map(cRs => {
            return { id: cRs.id, name: cRs.name }
        })


        setchannelList(listValue);


        setLoading(false)
    }


    const handleTabChange = (index) => {
        setActiveTab(index);
    };

    // Shared width for the pill tab bar and every card below it, so they
    // always end at exactly the same edge.
    const CONTENT_WIDTH = "800px";

    if (loading ) {
        return (
            <>
                <Header />
                <BoxWrapper >
                    <Flex justify="center" align="center" h="300px">
                        <Spinner size="lg" />
                    </Flex>
                </BoxWrapper>
            </>
        );
    }
    return (
        <>
            <Header header={header} />
            <BoxWrapper >
                {routePermission ? <Box>
                    <Box mb={5}>
                        <Text fontSize="lg" fontWeight="600" color="gray.800">Routing Methods</Text>
                        <Text fontSize="sm" color="gray.500" mt={1}>
                            Configure how notifications are routed for each message type.
                        </Text>
                    </Box>
                    <Tabs variant="unstyled" onChange={handleTabChange} isLazy>
                        <TabList bg="#f1f5f9" p="1" borderRadius="full" gap={1} w={CONTENT_WIDTH} maxW="100%" overflowX="auto" overflowY="hidden">
                            {['OTP', 'Transactions', 'Marketing', 'Informational'].map((label) => (
                                <Tab
                                    key={label}
                                    flex={1}
                                    px={4}
                                    py={1.5}
                                    borderRadius="full"
                                    fontSize="sm"
                                    fontWeight="500"
                                    color="gray.500"
                                    whiteSpace="nowrap"
                                    transition="all 0.15s"
                                    _hover={{ color: 'gray.700' }}
                                    _selected={{ bg: 'white', color: 'gray.800', fontWeight: '600', boxShadow: 'sm' }}
                                >
                                    {label}
                                </Tab>
                            ))}
                        </TabList>
                        <TabPanels>
                            <TabPanel px={0} pt={5}>
                                <Box className="box-style-card" w={CONTENT_WIDTH} maxW="100%" bg="white">
                                    <Otp customer_id={customer_id} channelData={channelList} message_type_id={1} num={Math.random()} />
                                </Box>
                            </TabPanel>
                            <TabPanel px={0} pt={5}>
                                <Box className="box-style-card" w={CONTENT_WIDTH} maxW="100%" bg="white">
                                    <Transactions customer_id={customer_id} message_type_id={2} channelData={channelList} />
                                </Box>
                            </TabPanel>
                            <TabPanel px={0} pt={5}>
                                <Box className="box-style-card" w={CONTENT_WIDTH} maxW="100%" bg="white">
                                    <Marketing customer_id={customer_id} message_type_id={3} channelData={channelList} />
                                </Box>
                            </TabPanel>
                            <TabPanel px={0} pt={5}>
                                <Box className="box-style-card" w={CONTENT_WIDTH} maxW="100%" bg="white">
                                    <Informational customer_id={customer_id} message_type_id={4} channelData={channelList} />
                                </Box>
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </Box> : <Box className='card-style'>
                    <Center h="400px">
                        <Box textAlign="center">
                            <Text fontSize="xl" fontWeight="semibold" color="gray.700" mb={2}>
                                No Access
                            </Text>
                            <Text fontSize="sm" color="gray.500">
                                You don't have permission to view this sections.
                            </Text>
                        </Box>
                    </Center>
                </Box>}

            </BoxWrapper>
        </>

    )
}
export default RoutingMethods